import type { FC } from "react";

type MaticWordmarkFooterProps = {
  classes?: string;
};

/**
 * The pre-2026 wordmark, kept for the footer's oversized bleed only: the Figma
 * redraw is proportionally taller (3.4808 against 3.6094) and cannot fill the
 * footer's fixed-aspect clipping box the way this one does.
 *
 * Deliberately not `MaticLogo` — different artwork, do not de-duplicate.
 */
const MaticWordmarkFooter: FC<MaticWordmarkFooterProps> = ({ classes }) => (
  <svg
    width="87"
    height="24"
    fill="currentColor"
    viewBox="0 0 86.625 24"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.266 10.3523C33.6153 10.3523 33.1009 10.8814 33.1009 11.5158V16.7747C33.1009 17.4246 33.6307 17.9382 34.266 17.9382H39.2218V23.7726H34.266C30.3911 23.7726 27.2582 20.6442 27.2582 16.7747V11.3488C27.2582 7.4793 30.3911 4.29053 34.266 4.29053H34.7045C41.3638 4.29053 46.7665 9.74596 46.7665 16.3958V23.7558H40.9239V16.5614C40.9239 13.1312 38.1396 10.334 34.6877 10.334H34.2492L34.2646 10.3495L34.266 10.3523Z"
    />
    <path d="M62.8356 0.00842105C62.8356 1.64351 64.168 2.9614 65.8054 2.9614C67.4428 2.9614 68.7625 1.64351 68.7752 0.00842105H62.8356Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M62.8791 23.7726V4.52491H68.7218V23.774H62.8791V23.7726Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M76.1063 16.866C76.1063 17.5003 76.6361 18.014 77.2714 18.014H86.625V23.7726H77.2714C73.3965 23.7726 70.2636 20.6891 70.2636 16.866V16.4281C70.2636 9.86947 75.6663 4.53333 82.3256 4.53333H86.6236V10.3214H82.3256C78.8905 10.3214 76.0894 13.0274 76.0894 16.4126V16.8505L76.1049 16.866H76.1063Z"
    />
    <path d="M9.89751 14.8716C9.89751 12.4982 8.12658 10.64 5.84125 10.3382V23.774H0V9.4007C0 6.52912 2.25442 4.27649 5.55452 4.27649C8.85463 4.27649 10.2166 5.28842 11.8961 6.43789C12.925 5.36421 13.8329 4.3214 16.1182 4.27649C20.5835 4.18526 25.6222 8.35649 25.6222 14.6891V23.7572H19.7796V14.8547C19.7796 12.4814 18.0086 10.6232 15.7233 10.3214V23.7572H9.88064V14.8547L9.89611 14.8702L9.89751 14.8716Z" />
    <path d="M55.9036 12.0154V16.3326H55.905V17.0919C55.905 17.5579 55.527 17.9354 55.0603 17.9354C54.5937 17.9354 54.2156 17.5579 54.2156 17.0919V16.2779C54.2156 16.2372 54.2142 16.1979 54.2142 16.1558V10.3368H61.0407V4.53333H54.2142V0H48.4025V17.6828C48.4025 21.1733 51.2332 24 54.7286 24C58.2241 24 61.0548 21.1733 61.0548 17.6828V12.0154H55.9036Z" />
  </svg>
);

export default MaticWordmarkFooter;
